import type { FunctionComponent, PropsWithChildren } from 'react';

import { useModifiers } from '../../../styles/hooks/useModifiers';
import { DirectionProps } from '../gameWingItem';

import styles from './gameWing.module.css';

export interface GameWingProps extends PropsWithChildren {
  direction?: DirectionProps;
}

export const GameWing: FunctionComponent<GameWingProps> = ({ direction = DirectionProps.start, children }) => {
  const mods = useModifiers(styles, 'gameWing', {
    start: direction === DirectionProps.start,
    end: direction === DirectionProps.end,
  });

  return <div className={`${styles.gameWing} ${mods}`}>{children}</div>;
};
